import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const HEADERS = [
  "SR. NO.",
  "DATE",
  "SAC CODE",
  "CLIENT NAME",
  "GST NO.",
  "AMOUNT",
  "GST",
  "WITHOUT GST",
  "INVOICE NO.",
  "COMPANY NAME",
];

const rowToArray = (row) => [
  row.serialNo,
  row.date,
  row.sacCode,
  row.clientName,
  row.gstNo,
  row.amount,
  row.gst,
  row.withoutGst,
  row.invoiceNo,
  row.companyName,
];

export const downloadInvoiceReportExcel = (rows, fileName = "all_invoices.xlsx") => {
  const worksheetData = [HEADERS, ...rows.map(rowToArray)];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  worksheet["!cols"] = [
    { wch: 8 },
    { wch: 12 },
    { wch: 10 },
    { wch: 55 },
    { wch: 18 },
    { wch: 14 },
    { wch: 8 },
    { wch: 14 },
    { wch: 14 },
    { wch: 36 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, fileName);
};
